import { render, staticRenderFns } from "./TipoContato.vue?vue&type=template&id=328b3259"
import script from "./TipoContato.vue?vue&type=script&lang=js"
export * from "./TipoContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports